import { render, staticRenderFns } from "./MarketCatalogProducts.vue?vue&type=template&id=24ede5db&scoped=true&"
import script from "./MarketCatalogProducts.vue?vue&type=script&lang=js&"
export * from "./MarketCatalogProducts.vue?vue&type=script&lang=js&"
import style0 from "./MarketCatalogProducts.vue?vue&type=style&index=0&id=24ede5db&lang=postcss&scoped=true&"
import style1 from "./MarketCatalogProducts.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ede5db",
  null
  
)

export default component.exports